<template>
  <a-card :bordered="false">
    <a-row>
      <a-col :span="8">
        <a-button type="primary" @click="openModel">添加供应商</a-button>
      </a-col>
      <!--      <a-col :span="8" :offset="8" style="text-align: right;"><a-button  @click="goRules">同步规则</a-button></a-col>-->
    </a-row>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :columns="getColumns()"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <span slot="statusSlots" slot-scope="rowItem">
        <span>{{ rowItem.record.status == 1 ? '启用' : '禁用' }}</span>
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.status==0" @click="onUpdateEvent(rowItem.record.id,1)">启用</a>
        <a v-else @click="onUpdateEvent(rowItem.record.id,0)">禁用</a>
        <a-divider type="vertical"/>
        <a @click="copyPublicKey(rowItem.record.selfPublicKey)">复制ota公钥</a>
      </span>
    </custom-page-table>
    <a-modal title="添加供应商" width="750px" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
        <a-form-model-item label="供应商名称" prop="supplierName">
          <a-input v-model.trim="ruleForm.supplierName" :maxLength="6"
                   placeholder="仅用于区分标识数据来源，6个字内"></a-input>
        </a-form-model-item>
        <a-form-model-item label="接口地址(URL)" prop="supplierUrl">
          <a-textarea v-model.trim="ruleForm.supplierUrl" placeholder="接口地址(URL)" :maxLength="300"
                      :auto-size="{ minRows: 2, maxRows: 5 }"></a-textarea>
        </a-form-model-item>
        <a-form-model-item label="商户id(mer_no)" prop="supplierMerNo">
          <a-input v-model.trim="ruleForm.supplierMerNo" placeholder="商户id(mer_no)" :maxLength="300"></a-input>
        </a-form-model-item>
        <a-form-model-item label="加密key(key)" prop="supplierKey">
          <a-input v-model.trim="ruleForm.supplierKey" placeholder="加密key(key)" :maxLength="300"></a-input>
        </a-form-model-item>
        <a-form-model-item label="长隆公钥(chimeLongPublicKey)" prop="supplierPublicKey">
          <a-textarea v-model.trim="ruleForm.supplierPublicKey" placeholder="长隆公钥(chimeLongPublicKey)"
                      :auto-size="{ minRows: 8, maxRows: 16 }" :maxLength="1000"></a-textarea>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 16, offset: 8 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="width: 180px;">提交</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import ChimelongTicketMixins from './ChimelongTicketMixins'

export default {
  name: 'ChimelongNewAccount',
  mixins: [ChimelongTicketMixins],
  data() {
    return {
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params),
      visible: false,
      submitLoading: false,
      ruleForm: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        supplierName: '',//供应商名称
        supplierUrl: '',//供应商接口地址
        supplierKey: '',//加密key
        supplierMerNo: '',//商户id
        supplierPublicKey: ''//长隆公钥key
      },
      rules: {
        supplierName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        supplierUrl: [{ required: true, message: '请输入接口地址', trigger: 'blur' }],
        supplierMerNo: [{ required: true, message: '请输入商户id', trigger: 'blur' }],
        supplierKey: [{ required: true, message: '请输入加密key', trigger: 'blur' }],
        supplierPublicKey: [{ required: true, message: '请输入长隆公钥(chimeLongPublicKey)', trigger: 'blur' }]
      }
    }
  },
  mounted() {
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getServerApiService().post('chimelong/ticket/list', params)
    },
    //启禁用事件
    onUpdateEvent(id, status) {
      let params = {
        id: id,
        status: status,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }
      this.getHttpServices().getServerApiService().post('chimelong/ticket/update-status', params).then(res => {
        this.$refs.table.refresh(true)
        this.$message.success('状态更新成功')
      }).catch(err => {
        this.getLogUtils().logWithTag('onUpdateEvent', err)
      })
    },
    //编辑事件
    editEvent(item) {
      let data = JSON.parse(JSON.stringify(item))
      this.ruleForm = data
      this.visible = true
    },
    copyPublicKey(copyText) {
      this.$copyText(copyText).then(message => {
        this.getLogUtils().logWithTag('copy', message)
        this.$message.success('复制成功')
      }).catch(err => {
        this.getLogUtils().logWithTag('copy.err', err)
        this.$message.error('复制失败')
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!', '错误')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getHttpServices().getServerApiService().post('chimelong/ticket/save-edit', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('数据更新成功')
        this.visible = false
        this.resetFrom()
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    openModel() {
      this.resetFrom()
      this.visible = true
    },
    resetFrom() {
      this.ruleForm = {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        supplierName: '',//供应商名称
        supplierUrl: '',//供应商接口地址
        supplierKey: '',//加密key
        supplierMerNo: '',//商户id
        id: 0,//主键ID
        supplierPublicKey: ''//长隆公钥key
      }
    },
    handleCancel() {
      this.visible = false
    },
    goRules() {
      this.$router.push({
        name: 'ChimelongAsyncRule',
        query: {
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    getColumns() {
      return [
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '商户id(mer_no)',
          dataIndex: 'supplierMerNo'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'statusSlots' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped></style>
